import { createModule } from '../../createModule';
import { parseInput } from '../../shared';
import * as BucketsSchemas from './buckets.schemas';
export const createBucketsAPI = createModule(({ http }) => {
    return {
        getAll: async () => {
            const res = await http.get(`/v2/buckets/`);
            return res;
        },
        create: async (body) => {
            const params = parseInput(BucketsSchemas.createBucketSchema, body);
            const res = await http.post(`/v2/buckets/`, { body: params });
            return res;
        },
        update: async (body) => {
            const res = await http.patch(`/v2/buckets/`, { body: body });
            return res;
        },
        delete: async ({ bucket_id }) => {
            const params = parseInput(BucketsSchemas.deleteBucketSchema, { bucket_id });
            const res = await http.delete(`/v2/buckets/${params.bucket_id}`);
            return res;
        },
        getTopLevelBuckets: async () => {
            const res = await http.get('/v2/static/buckets/TOP_LEVEL');
            return res;
        },
        getInvestmentBuckets: async () => {
            const res = await http.get('/v2/static/buckets/INVESTMENT_TYPE');
            return res;
        },
        getWrapperBuckets: async () => {
            const res = await http.get('/v2/static/buckets/WRAPPER');
            return res;
        },
    };
});
